import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AnnouncementChyron from "@/components/AnnouncementChyron";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import RecordingCalendar from "@/components/atfq/RecordingCalendar";

export default function CalendarPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Recording Calendar · ATFQ";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <main className="bg-white text-[#0A192F] min-h-screen">
      <AnnouncementChyron />
      <Nav />
      <section data-testid="calendar-page" className="pt-40 md:pt-48 pb-24">
        <div className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto">
          <Link to="/" data-testid="calendar-back" className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-[#0A192F] mb-8">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to ATFQ
          </Link>
          <RecordingCalendar standalone />
        </div>
      </section>
      <Footer />
    </main>
  );
}
